
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Image from "next/image";
import Link from "next/link";
import { Fragment, useEffect } from "react";
import { MegaMenuContentQuery } from "../../graphql/MegaMenuContent.gql";
import { storeLogoQuery } from "../../graphql/storeLogo.gql";
import IconBxChevronUp from "../icons/IconBxChevronUp";
import IconBxPlus from "../icons/IconBxPlus";
import IconBxStopwatch from "../icons/IconBxStopwatch";
import IconBxsHot from "../icons/IconBxsHot";
import HeaderLogo from "./HeaderLogo";
import MobileLoginBtns from "./MobileLoginBtns";





type Props = MegaMenuContentQuery & storeLogoQuery

// eslint-disable-next-line import/no-default-export
export default function BottomNavbar({ amMegaMenuTree, storeLogo }: Props) {
  const items = amMegaMenuTree?.items;

  const getSectionGrid = (menuIndex: string, sectionIndex: number) => {
    if (menuIndex === 'MTI3MQ==') {
      if (sectionIndex === 0 || sectionIndex === 1) return ' flex-1 992:flex-[33.3333%] 992:border-l border-solid border-light-170';
      if (sectionIndex === 2 || sectionIndex === 3) return ' flex-1 992:flex-[16.66665%]';
    }

    if (menuIndex === "Ng==") {
      return `flex-1 992:flex-[17.5%] ${sectionIndex !== 3 && '992:border-l border-solid border-light-170'}`;
    }
    return 'flex-1';
  }

  return (
    <div className="bg-white 992:bg-light-50 shadow-md 992:h-14 992:w-full 992:block fixed  top-0 right-0 border-light !translate-x-[100%] 992:!translate-x-0 bottom-0 w-[16rem] 992:relative z-[9] overflow-y-scroll 992:overflow-y-visible transition" id="MobileMenu">
      <div className="flex 992:items-center flex-col 992:flex-row  h-full max-w-970 1300:max-w-1300 mx-auto relative">
        <nav>
          <ul className="flex flex-col  992:flex-row items-stretch h-14">

            <li className="flex bg-primary-500 justify-between 992:hidden py-3 px-4">
              <MobileLoginBtns />
              <HeaderLogo white storeLogo={storeLogo} />
            </li>
            <li className="px-2 992:hidden 1300:flex transition-colors hover:bg-light-170 flex items-center group border 992:border-0 border-solid border-light-50 border-x-0 border-t-0">
              <Link href="/" className="text-default-400 text-sm font-bold 992:font-normal 992:text-sm flex gap-1 items-center py-4 992:py-0">
                صفحه اصلی
              </Link>
            </li>

            {items ? <>
              {items[0]?.children?.filter(i => i?.include_in_menu === 1)?.map((item) => (<li key={item?.uid} className="992:px-2 transition-colors md:hover:bg-light-170 flex flex-col items-stretch 992:flex-row 992:items-center group  border 992:border-0 border-solid border-light-50 border-x-0 border-t-0">
                {item?.children && item.children.length && <span className="h-full bg-light-150 justify-center items-center  text-light-200 w-8 hidden 992:flex 1300:hidden">
                  <IconBxPlus width={18} height={18} />
                </span>}
                <Link href={item?.url_path ? `/${item?.url_path}` : "/"} className="text-default-400 hidden 992:inline-block 992:font-normal 992:text-sm 992:py-0">
                  {item?.name}
                </Link>

                <Link
                  href={item?.children && item.children.length ? 'javascript:void(0)' : '#'}
                  className="text-default-400 pl-2 992:hidden pr-10 text-sm font-bold  py-4 flex flex-1 justify-between menuLink"

                >
                  {item?.name}

                  {item?.children && item.children.length && <IconBxChevronUp width={18} height={18} className="!rotate-180" />}
                </Link>


                {item?.children && item.children.length && (
                  <div className="992:absolute hidden 992:opacity-0 992:group-hover:block 992:group-hover:opacity-100 right-0 left-0 max-w-970 1300:max-w-1300 top-[100%] pt-2 mobileSubMenu">
                    <div className="bg-[#eee] 992:bg-[#fefefe] 992:rounded-sm 992:shadow-sm  pr-10 992:p-4 py-3">

                      <Link href={item.url ? `/${item.url}` : "/"} className="text-default-400 992:hidden text-sm font-bold py-4 flex-1 justify-between">
                        مشاهده همه محصولات این دسته
                      </Link>
                      <ul className="flex flex-col 992:flex-row">{item.children?.filter(i => i?.include_in_menu === 1)?.map((subMenu, index2) => (<Fragment key={subMenu?.uid}>
                        <li className={getSectionGrid(item.uid!, index2)}>
                          <Link href={subMenu?.url ? `/${subMenu?.url}` : '/'} className="text-sm text-primary-500 font-bold py-4 992:py-0 inline-block">{subMenu?.name}</Link>
                          <ul className="flex 992:flex-wrap flex-col 992:max-h-[20rem] justify-between w-full gap-y-2.5 mt-2">
                            {subMenu?.children && subMenu?.children?.length && subMenu?.children?.filter(i => i?.include_in_menu === 1)?.map((subSubMenu) => (
                              <li key={subSubMenu?.uid} className="w-fit">
                                <Link href={subSubMenu?.url_path ? `/${subSubMenu?.url_path}` : '/'} className="text-xs font-normal text-default-400 hover:text-primary-500 transition-colors w-fit">{subSubMenu?.name}</Link></li>)
                            )}</ul>
                        </li>

                        {item?.children && index2 < item?.children?.length - 1 && <li className="bg-light-170 w-[1px] mx-3 h-full" />}

                      </Fragment>))}

                        {item.uid === 'Ng==' ? <li className="hidden 992:flex flex-[30%] justify-end ">
                          <Image src="/static-image/fragrance-image.jpg" width={272} height={150} alt={item.label ?? ''} />
                        </li> : null}
                      </ul>
                    </div>

                  </div>
                )}
              </li>))}
            </> : null}


            <li className="px-2 992:hidden 1300:flex transition-colors hover:bg-light-170 flex items-center group border 992:border-0 border-solid border-light-50 border-x-0 border-t-0">
              <Link href="/brand" className="text-default-400 text-sm font-bold 992:font-normal 992:text-sm flex gap-1 items-center py-4 992:py-0">
                برندها
              </Link>
            </li>

            <li className="px-2 transition-colors hover:bg-light-170 flex items-center group border 992:border-0 border-solid border-light-50 border-x-0 border-t-0">
              <Link href="/blog" className="text-default-400 text-sm font-bold 992:font-normal 992:text-sm flex gap-1 items-center py-4 992:py-0">
                مجلهٔ زیبایی
              </Link>
            </li>

            <li className="px-2 transition-colors hover:bg-light-170 flex items-center group border 992:border-0 border-solid border-light-50 border-x-0 border-t-0">
              <Link href="/package?filterbystock=1" className="text-default-400 text-sm font-bold 992:font-normal 992:text-sm flex gap-1 items-center py-4 992:py-0">
                پکیج‌ها
              </Link>
            </li>

            <li className="px-2 992:hidden 1300:flex transition-colors hover:bg-light-170 flex items-center group border 992:border-0 border-solid border-light-50 border-x-0 border-t-0">
              <Link href="/special-offers/closing-expiration-date" className="text-default-400 text-sm font-bold 992:font-normal 992:text-sm flex gap-1 items-center py-4 992:py-0">
                <IconBxStopwatch className="text-error-500 " width={24} height={24} />
                زود مصرف ها
              </Link>
            </li>

            <li className="px-2 transition-colors hover:bg-light-170 flex items-center group 992:pr-0">
              <Link href="/products?filterbystock=1&limit=48&islayerajax=1" className="text-error-500 text-sm font-bold 992:font-normal 992:text-sm flex gap-1 items-center py-4 992:py-0">
                <IconBxsHot width={24} height={24} />
                پر فروش ترین ها
              </Link>
            </li>
          </ul>
        </nav>
      </div>
      <Scripts />
    </div>
  )
}


function Scripts() {
  useEffect(() => {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      const mobileSubMenus = document.querySelectorAll(".mobileSubMenu")!;
      const menuLinks = document.querySelectorAll(".menuLink")!;


      menuLinks.forEach(item => item.addEventListener("click", () => {

        if (item.nextElementSibling?.classList.contains('!block')) {
          item.nextElementSibling?.classList.remove('!block');
          item.querySelector('svg')?.classList.add('!rotate-180');

        } else {
          mobileSubMenus.forEach(i => i.classList.remove('!block'));
          item.nextElementSibling?.classList.add('!block');
          item.querySelector('svg')?.classList.remove('!rotate-180');
        }
      }));



      /*  openMobileMenu.addEventListener('click', () => {
         if (menuBackDrop && MobileMenu) {
           menuBackDrop.classList.add('!block');
           MobileMenu.classList.add('!block');
           menuBackDrop.classList.add('!opacity-100');
     
         }
       }) */
    }
  }, [])
  return null;
}
